/* ============================================================
   BONEANTHONY — Cart Drawer JS
   - Opens on cart-icon click + on the global ba:cart:added event
   - AJAX qty change + remove using /cart/change.js with the
     Sections API so we get rendered HTML back in one round-trip
   - Body scroll lock while open
   - ESC to close, click-outside-to-close
   - Re-syncs header cart count after every update
   ============================================================ */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  // ----------------------------------------------------------
  // Money formatter (shared with ba-product-form.js style)
  // ----------------------------------------------------------
  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    return '₹' + (cents / 100).toFixed(2);
  }

  // ----------------------------------------------------------
  // Header cart count sync (mirrors ba-product-form.js)
  // ----------------------------------------------------------
  function updateHeaderCartCount(count) {
    var bubbles = $$('[data-cart-count-bubble], cart-icon-bubble, .ba-header__cart-count, [data-cart-count]');
    bubbles.forEach(function (el) {
      var num = el.querySelector('[data-cart-count]') || el;
      if (count > 0) {
        num.textContent = count;
        el.classList.add('has-items');
        el.classList.remove('is-empty');
        el.removeAttribute('hidden');
      } else {
        num.textContent = '0';
        el.classList.remove('has-items');
        el.classList.add('is-empty');
      }
    });
  }

  // ----------------------------------------------------------
  // The drawer controller
  // ----------------------------------------------------------
  function Drawer(el) {
    this.el = el;
    this.sectionId = el.dataset.sectionId;
    this.content = $('[data-ba-cd-content]', el);
    this.panel = $('.ba-cd__panel', el);
    this.lastFocus = null;
    this.bindContent();
    this.bindOpeners();
    this.bindClosers();
    this.bindKeyboard();
    this.bindCartAddedEvent();
    this.applyTierGridCount();
  }

  Drawer.prototype.applyTierGridCount = function () {
    var tier = $('[data-ba-tier]', this.el);
    if (!tier) return;
    var count = $$('.ba-cd__tier-marker', tier).length;
    if (count > 0) {
      tier.style.setProperty('--tier-count', count);
    }
  };

  Drawer.prototype.open = function () {
    if (this.el.classList.contains('is-open')) return;
    this.lastFocus = document.activeElement;
    this.el.removeAttribute('hidden');
    // Force reflow so the transition runs
    void this.el.offsetWidth;
    this.el.classList.add('is-open');
    this.el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ba-cd-open');
    // Focus the panel for accessibility
    var self = this;
    setTimeout(function () {
      if (self.panel && self.panel.focus) self.panel.focus();
    }, 60);
  };

  Drawer.prototype.close = function () {
    if (!this.el.classList.contains('is-open')) return;
    this.el.classList.remove('is-open');
    this.el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ba-cd-open');
    // Hide after animation completes
    var self = this;
    setTimeout(function () {
      if (!self.el.classList.contains('is-open')) {
        self.el.setAttribute('hidden', '');
      }
    }, 400);
    if (this.lastFocus && this.lastFocus.focus) {
      this.lastFocus.focus();
    }
  };

  Drawer.prototype.toggle = function () {
    if (this.el.classList.contains('is-open')) this.close();
    else this.open();
  };

  // ---- Bind opener clicks anywhere in the document ----
  Drawer.prototype.bindOpeners = function () {
    var self = this;
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-action="open-cart"]')
                 || e.target.closest('[data-ba-cart-open]')
                 || e.target.closest('a[href$="/cart"]');
      if (trigger) {
        // Don't intercept middle-click / cmd-click
        if (e.button === 1 || e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        // Open INSTANTLY — the drawer section is server-rendered with the
        // current cart on every page load, so there is no need to block the
        // slide-in on a network round-trip. refresh() (two sequential
        // fetches: section render + /cart.js) runs silently in the
        // background to reconcile cross-tab changes — no loading dim, so the
        // content is fully visible and interactive the instant it opens.
        self.open();
        self.refresh();
      }
    });
  };

  Drawer.prototype.bindClosers = function () {
    var self = this;
    $$('[data-ba-cd-close]', this.el).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        self.close();
      });
    });
  };

  Drawer.prototype.bindKeyboard = function () {
    var self = this;
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.el.classList.contains('is-open')) {
        self.close();
      }
    });
  };

  Drawer.prototype.bindCartAddedEvent = function () {
    var self = this;
    document.addEventListener('ba:cart:added', function () {
      // PDP add-to-cart fires this. Open instantly for a snappy feel;
      // refresh() silently repaints the section with the just-added line
      // when the fetch returns (no loading dim — see refresh()).
      self.open();
      self.refresh();
    });
  };

  // ---- Item-level handlers (qty +/-, remove) ----
  Drawer.prototype.bindContent = function () {
    var self = this;
    if (!this.content) return;

    this.content.addEventListener('click', function (e) {
      var dec = e.target.closest('[data-ba-cd-qty-dec]');
      var inc = e.target.closest('[data-ba-cd-qty-inc]');
      var rem = e.target.closest('[data-ba-cd-remove]');
      var item = (dec || inc || rem) ? (dec || inc || rem).closest('.ba-cd__item') : null;
      if (!item) return;

      var input = item.querySelector('[data-ba-cd-qty-input]');
      var line = parseInt(item.dataset.line, 10);
      var currentQty = parseInt(input.value, 10) || 0;

      if (dec) {
        e.preventDefault();
        self.updateLine(line, Math.max(0, currentQty - 1), item);
      } else if (inc) {
        e.preventDefault();
        self.updateLine(line, currentQty + 1, item);
      } else if (rem) {
        e.preventDefault();
        self.updateLine(line, 0, item);
      }
    });

    // Allow typing a new qty directly
    this.content.addEventListener('change', function (e) {
      var input = e.target.closest('[data-ba-cd-qty-input]');
      if (!input) return;
      var item = input.closest('.ba-cd__item');
      var line = parseInt(item.dataset.line, 10);
      var newQty = Math.max(0, parseInt(input.value, 10) || 0);
      self.updateLine(line, newQty, item);
    });
  };

  // ---- AJAX line update with Sections API ----
  Drawer.prototype.updateLine = function (line, quantity, itemEl) {
    var self = this;
    this.el.classList.add('is-loading');
    if (itemEl && quantity === 0) itemEl.classList.add('is-removing');

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: 'ba-cart-drawer-section,' + this.sectionId
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        // data.sections may contain rendered HTML for our section
        self.renderFromSectionsResponse(data);
        updateHeaderCartCount(data.item_count !== undefined ? data.item_count : self.countItems(data));
        document.dispatchEvent(new CustomEvent('ba:cart:updated', { detail: { cart: data } }));
      })
      .catch(function (err) {
        console.error('[ba-cart-drawer] update failed', err);
      })
      .finally(function () {
        self.el.classList.remove('is-loading');
      });
  };

  // ---- Refresh drawer contents from /cart (used on open) ----
  Drawer.prototype.refresh = function () {
    var self = this;
    // NOTE: refresh() runs in the BACKGROUND on open — the drawer is already
    // server-rendered with the current cart, so we deliberately do NOT add
    // `is-loading` here. Doing so dimmed the content to 0.5 opacity and set
    // pointer-events:none for the full duration of the two sequential fetches
    // (~1.2s measured), which made the just-opened drawer look frozen and
    // un-clickable — the real cause of the "slow open" report. The content
    // swap (replaceContents) happens silently when the fetch returns.
    // `is-loading` is reserved for updateLine() (qty change / remove), where
    // the user takes an action and expects visible feedback.
    // Hit the section render URL so we get just our section HTML back.
    // Append a cache-buster to avoid Shopify's edge cache showing a stale render.
    var url = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart')
            + '?section_id=' + encodeURIComponent(this.sectionId)
            + '&_=' + Date.now();
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        self.replaceContents(html);
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (r) { return r ? r.json() : null; })
      .then(function (cart) {
        if (cart) updateHeaderCartCount(cart.item_count);
      })
      .catch(function (err) {
        console.error('[ba-cart-drawer] refresh failed', err);
      });
    // No `is-loading` cleanup here — refresh() no longer sets it (see note
    // above). is-loading is owned solely by updateLine().
  };

  // ---- Re-render from /cart/change.js sections response ----
  Drawer.prototype.renderFromSectionsResponse = function (data) {
    if (!data || !data.sections) return;
    // Shopify returns each section's HTML keyed by the section id we asked for.
    // Iterate keys and pick the one that matches ours.
    var html = null;
    for (var key in data.sections) {
      if (data.sections[key]) { html = data.sections[key]; break; }
    }
    if (!html) return;
    this.replaceContents(html);
  };

  // ---- Replace the drawer's inner content + sticky footer from server HTML ----
  Drawer.prototype.replaceContents = function (html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var newDrawer = tmp.querySelector('[data-ba-cart-drawer]');
    if (!newDrawer) return;
    var newContent = newDrawer.querySelector('[data-ba-cd-content]');
    var newFooter = newDrawer.querySelector('.ba-cd__footer');
    var currentContent = this.content;
    var currentFooter = $('.ba-cd__footer', this.el);
    var panel = this.panel;

    if (newContent && currentContent) {
      currentContent.innerHTML = newContent.innerHTML;
    }
    // Footer toggles existence based on cart count — handle both add and remove
    if (newFooter) {
      if (currentFooter) {
        currentFooter.outerHTML = newFooter.outerHTML;
      } else if (panel) {
        panel.appendChild(newFooter.cloneNode(true));
      }
    } else if (currentFooter) {
      currentFooter.remove();
    }

    this.applyTierGridCount();
  };

  Drawer.prototype.countItems = function (cartData) {
    if (!cartData || !cartData.items) return 0;
    return cartData.items.reduce(function (sum, it) { return sum + (it.quantity || 0); }, 0);
  };

  // ----------------------------------------------------------
  // Init
  // ----------------------------------------------------------
  function init() {
    $$('[data-ba-cart-drawer]').forEach(function (el) {
      if (el.dataset.baBound === '1') return;
      el.dataset.baBound = '1';
      new Drawer(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on theme editor section load
  document.addEventListener('shopify:section:load', function (e) {
    var sec = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (!sec) return;
    var drawer = sec.querySelector('[data-ba-cart-drawer]');
    if (drawer) {
      drawer.dataset.baBound = '';
      new Drawer(drawer);
    }
  });
})();
